import { Action } from '@ngrx/store';
import { IIndirectStructure, IIndirectStructureResponse } from '../IIndirectStructure';


export enum ActionTypes {
  Reset = '[indirectjobs] Reset',
  LoadIndirectJobs = '[indirectjobs] Load Indirect Jobs',
  SetIndirectJobs = '[indirectjobs] Set Indirect Jobs',
  UpdateIndirectJobs = '[indirectjobs] Update Indirect Jobs',
  UpdateIndirectJobsSuccess = '[indirectjobs] Update Indirect Jobs Success',
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export class LoadIndirectJobs implements Action {
  constructor() { }
  readonly type = ActionTypes.LoadIndirectJobs;
}

export class SetIndirectJobs implements Action {
  constructor(public payload: Array<IIndirectStructure>) {
  }
  readonly type = ActionTypes.SetIndirectJobs;
}

export class UpdateIndirectJobs implements Action {
  constructor(public payload: Array<IIndirectStructure>) { }
  readonly type = ActionTypes.UpdateIndirectJobs;
}

export class UpdateIndirectJobsSuccess implements Action {
  constructor(public payload: IIndirectStructureResponse) { }
  readonly type = ActionTypes.UpdateIndirectJobsSuccess;
}

export type ActionsUnion = LoadIndirectJobs | SetIndirectJobs | UpdateIndirectJobs | UpdateIndirectJobsSuccess | Reset;
